import styled from "styled-components";

export const ItemContainer = styled.div`
  padding-bottom: var(--fd-space-space-1);
`;
